<template>
  <div>
    <el-card body-style="padding: 0;padding-right:2%">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="用户编号" prop="customerId">
              <el-input
                v-model="queryForm.customerId"
                placeholder="请输入用户编号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="用户名" prop="customerName">
              <el-input
                v-model="queryForm.customerName"
                placeholder="请输入用户名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="上级用户" prop="upBusinessUser">
              <el-input
                v-model="queryForm.upBusinessUser"
                placeholder="请输入上级用户"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属业务员" prop="businessUser">
              <el-input
                v-model="queryForm.businessUser"
                placeholder="请输入业务员"
              />
            </el-form-item>
          </el-col>
          <!--<el-col :span="5">
            <el-form-item label="用户类型" prop="usertype">
              <el-select v-model="queryForm.usertype" clearable placeholder="请选择用户类型">
                <el-option
                    v-for="item in allUserType"
                    :key="item.userTypeNum"
                    :label="item.userTypeName"
                    :value="item.userTypeName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="昵称" prop="userNickname">
              <el-input
                v-model="queryForm.userNickname"
                placeholder="请输入昵称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="真实姓名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份证" prop="idCardNum">
              <el-input
                v-model="queryForm.idCardNum"
                placeholder="请输入身份证号码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click="submitQueryForm()"
                icon="el-icon-search"
              >
                查询
              </el-button>
              <el-button
                type="primary"
                size="small"
                plain
                @click="resetQueryForm()"
                icon="el-icon-refresh"
              >
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button
        type="primary"
        size="mini"
        style="margin: 0 0 10px 20px"
        icon="el-icon-warning-outline"
        @click="handleUnenableOrEnable(false)"
        >限制接单</el-button
      >
      <el-button
        type="primary"
        size="mini"
        style="margin: 0 0 10px 20px"
        icon="el-icon-warning-outline"
        @click="handlerEnableLowerOrder(false)"
        >限制下级接单</el-button
      >
      <el-button
        type="info"
        size="mini"
        style="margin: 0 0 10px 20px"
        @click="handleUnenableOrEnable(true)"
        >开启接单</el-button
      >
      <el-button
        type="info"
        size="mini"
        style="margin: 0 0 10px 20px"
        @click="handlerEnableLowerOrder(true)"
        >开启下级接单</el-button
      >
      <el-button
        type="primary"
        size="mini"
        style="margin: 0 0 10px 20px"
        @click="handleImportData('导入用户数据')"
        >导入试客</el-button
      >
      <el-table
        :data="tableData"
        ref="table"
        border
        default-expand-all
        stripe
        :header-cell-style="{ 'text-align': 'center' }"
        :max-height="tableHeight"
        style="width: 100%;margin-bottom: 20px;"
        :cell-style="{ textAlign: 'center' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column label="全选" width="50" type="selection" />
        <el-table-column prop="customerId" width="85" label="用户ID">
          <!--<template slot-scope="scope">
            <span>{{ getStrEndWithNumbers(scope.row.customerId) }}</span>
          </template>-->
        </el-table-column>
        <el-table-column prop="customerName" label="用户名" />
        <el-table-column prop="userName" label="真实姓名" />
        <el-table-column prop="idCardNum" width="162" label="身份证" />
        <el-table-column prop="roleCode" label="用户类型">
          <template slot-scope="scope">
            <span>{{
              scope.row.roleCode == "customer" ? "试客" : "主播"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="upBusinessUser" label="上级用户">
          <template slot-scope="scope">
            <span>{{
              scope.row.upBusinessUser == "admin"
                ? ""
                : scope.row.upBusinessUser
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shareCode" label="分享码" />
        <el-table-column prop="balanceMoney" label="余额" />
        <el-table-column prop="orderNumbers" label="订单数" />
        <el-table-column prop="commissionMoney" label="佣金" />
        <el-table-column prop="freeMoney" label="冻结" />
        <el-table-column prop="accountInfos" width="120" label="账号">
          <template slot-scope="scope">
            <span>
              <div>系统配置:</div>
              <div v-for="acItem in scope.row.accountInfos">
                <span
                  >{{ acItem.plateformName }}:<span>{{
                    acItem.accountUsedNum
                  }}</span
                  >/{{ acItem.accountNumTotal }}</span
                >
              </div>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="statusStr" label="状态" />
        <el-table-column prop="enableOrder" label="接单允许">
          <template slot-scope="scope">
            <span style="color: red;">{{
              scope.row.isReciveOrder ? "允许" : "不允许"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="registeTime" width="120" label="注册时间" />
        <el-table-column prop="businessUser" label="业务员" />
        <el-table-column prop="isStart" label="是否启用">
          <template slot-scope="scope">
            <span style="color: #4481eb;">{{
              scope.row.isEnableUsed ? "启用" : "不启用"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注" />
        <el-table-column label="操作" width="268">
          <template slot-scope="scope">
            <el-row style="text-align:center;font-size: xx-small;">
              <el-col :span="16">
                <el-button
                  plain
                  size="mini"
                  type="primary"
                  v-if="!scope.row.isGrifter"
                  @click="uploadGifter(scope.$index, scope.row)"
                >
                  上传骗子库
                </el-button>
                <el-button
                  plain
                  size="mini"
                  type="danger"
                  v-else
                  @click="uploadGifter(scope.$index, scope.row)"
                >
                  移除骗子信息
                </el-button>
              </el-col>
              <el-col :span="8" v-show="isShowAccessField(1)">
                <el-button
                  plain
                  size="mini"
                  @click="setCustomerUpPerson(scope.$index, scope.row)"
                >
                  设置上级
                </el-button>
              </el-col>
            </el-row>
            <el-row
              style="text-align:center;margin-top: 5px;font-size: xx-small"
              :gutter="12"
            >
              <el-col :span="6">
                <el-button
                  plain
                  size="mini"
                  @click="customerSetting(scope.$index, scope.row)"
                >
                  设置
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button
                  plain
                  size="mini"
                  @click="reflushShareCode(scope.$index, scope.row)"
                >
                  刷新
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  v-if="scope.row.isEnableUsed"
                  @click="unEnableUser(scope.$index, scope.row)"
                >
                  禁用
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  v-else
                  @click="unEnableUser(scope.$index, scope.row)"
                >
                  开启
                </el-button>
              </el-col>
            </el-row>
            <el-row
              style="text-align:center;margin-top: 5px;font-size: xx-small"
              :gutter="12"
            >
              <el-col :span="11" v-show="isShowAccessField(2)">
                <el-button
                  plain
                  size="mini"
                  type="success"
                  v-if="
                    scope.row.isOpenShareCode == null ||
                      !scope.row.isOpenShareCode
                  "
                  @click="openCustomerShareCode(scope.$index, scope.row)"
                >
                  开启无限制邀请
                </el-button>
                <el-button
                  plain
                  size="mini"
                  type="danger"
                  v-else
                  @click="openCustomerShareCode(scope.$index, scope.row)"
                >
                  关闭无限制邀请
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button
                  plain
                  size="mini"
                  type="success"
                  @click="handleLoginCustomer(scope.$index, scope.row)"
                >
                  登录
                </el-button>
              </el-col>
              <el-col :span="6">
                <el-button
                  plain
                  size="mini"
                  type="success"
                  @click="goDetail(scope.$index, scope.row)"
                >
                  查看
                </el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px"
      >
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
        <el-form-item label="重审天数">
          <el-input
            type="number"
            v-model="dialogForm.statusReviewDays"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dialogForm.remarks" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="USDT地址配置">
          <el-radio-group v-model="dialogForm.isOpenConf">
            <el-radio :label="false">关闭</el-radio>
            <el-radio :label="true">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="dialogForm.isOpenConf">
          <el-form-item label="USDT收款地址">
            <el-input
              v-model="dialogForm.usdtAddress"
              style="width: 50%;"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="淘宝绑定账号 (个)">
            <el-input v-model="dialogForm.plateformAccountTaoLimit" style="width: 50%;"></el-input>
          </el-form-item>
          <el-form-item label="京东绑定账号 (个)">
            <el-input v-model="dialogForm.plateformAccountJdLimit" style="width: 50%;"></el-input>
          </el-form-item>
          <el-form-item label="拼多多绑定账号 (个)">
            <el-input v-model="dialogForm.plateformAccountPddLimit" style="width: 50%;"></el-input>
          </el-form-item>
          <el-form-item label="抖音绑定账号 (个)">
            <el-input v-model="dialogForm.plateformAccountDyLimit" style="width: 50%;"></el-input>
          </el-form-item>
          <el-form-item label="阿里巴巴绑定账号 (个)">
            <el-input v-model="dialogForm.plateformAccountAlbabaLimit" style="width: 50%;"></el-input>
          </el-form-item> -->
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary"
          >提交</el-button
        >
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="dialogUpersonTitle"
      :visible.sync="dialogUpersonFormVisible"
    >
      <el-form
        ref="dialogUpersonForm"
        :model="dialogUpersonForm"
        label-width="220px"
      >
        <el-form-item label="上级用户名">
          <el-input
            v-model="dialogUpersonForm.username"
            style="width: 50%;"
          ></el-input>
        </el-form-item>
        <el-form-item label="上级角色">
          <el-radio-group v-model="dialogUpersonForm.roleCode">
            <el-radio label="customer">试客</el-radio>
            <el-radio label="salesman">业务员</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitUpersonDialogForm()" size="mini" type="primary"
          >提交</el-button
        >
        <el-button @click="handleUpersonCloseDialog" size="mini"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="dialogImportDataTitle"
      :visible.sync="dialogImportDataFormVisible"
    >
      <el-form
        ref="dialogImportDataForm"
        :model="dialogImportDataForm"
        label-width="220px"
      >
        <el-row :gutter="20">
          <el-col :span="24" style="text-align: center">
            <el-link
              target="_blank"
              href="https://myb2c.oss-cn-hangzhou.aliyuncs.com/dataimporttemplate/customerTemplate.xlsx"
              :underline="false"
            >
              <el-button style="margin-bottom: 2%;" type="primary" plain
                >下载模版</el-button
              >
            </el-link>
            <div
              style="color: red;max-width: 90%;margin-left:2%;text-align: center;"
            >
              <span
                >模版为试客或者主播信息导入模版。如果增加其他角色，请联系管理</span
              >
              <div>如果有上下级关系， 请先导入最上级用户。切记</div>
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="24" style="text-align: center;">
            <el-upload
              class="avatar-uploader"
              drag
              action="https://api.weiquanai.com/b2cmanagepersons/customer/upload"
              :headers="myheader"
              :show-file-list="false"
              accept=".xlsx"
              :before-upload="onbeforeunloads"
              :on-success="importDataSuccess"
              :on-error="importDataError"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击导入</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xlsx文件，且不超过50MB
              </div>
            </el-upload>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from "@/components/MixinCUD";
import {
  changeLowerOrderEnable,
  changeOrderEnable,
  changeUserUsed,
  getCustomerSetting,
  openCustomerShareEnable,
  queryAdminLoginUser,
  queryCustomerList,
  setCustomerUpersonInfo,
  updateCustomerSetting,
  uploadToGrifter,
} from "../../api/b2cbusiness/b2c_customerinfo";
import { getJwtToken, getStrEndWithNumbers } from "../../lib/utils";
import { getAllUserType } from "../../api/b2cbusiness/b2c_admin";
import { reflushShareCode } from "../../api/b2cbusiness/b2c_sharecode";
import { Loading } from "element-ui";
import { queryRoleAccessField } from "@/api/system/sys_role";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "Customlist",
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      myheader: {
        JWTHeaderName: "",
      },
      tableData: [],
      allUserType: [],
      queryFormRefName: "queryForm",
      queryForm: {
        customerId: null,
        customerName: null,
        upBusinessUser: null,
        businessUser: null,
        userNickname: null,
        userName: null,
        idCardNum: null,
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {
        statusReviewDays: 30,
        remarks: "",
        isOpenConf: false,
      },
      dialogUpersonFormVisible: false,
      dialogUpersonTitle: "",
      dialogUpersonRefName: "dialogUpersonForm",
      dialogUpersonForm: {
        roleCode: "customer",
      },
      dialogImportDataFormVisible: false,
      dialogImportDataTitle: "导入用户数据",
      dialogImportDataRefName: "dialogImportDataForm",
      dialogImportDataForm: {},
      loadingInstance: null,
      tableHeight: 850,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null,
      },
      b2cAccessFieldInfos: [],
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  computed: {
    isShowAccessField() {
      return function(fieldId) {
        if (this.b2cAccessFieldInfos.length <= 0) {
          return false;
        } else {
          return (
            this.b2cAccessFieldInfos.filter((item) => item.id == fieldId)
              .length > 0
          );
        }
      };
    },
  },
  mounted() {
    this.myheader.JWTHeaderName = getJwtToken();

    getAllUserType().then((res) => {
      if (res.success) {
        console.log(res.data);
        this.allUserType = res.data;
      }
    });
    this.getData();

    /*获取字段权限*/
    queryRoleAccessField("试客列表", null)
      .then((res) => {
        if (res.success) {
          this.b2cAccessFieldInfos = res.data;
          //console.log(this.b2cAccessFieldInfos)
        }
      })
      .catch((err) => {
        this.$message({ message: err.message, type: "error" });
      });
  },
  methods: {
    submitUpersonDialogForm() {
      this.$confirm("确认设置试客上级吗？").then((_) => {
        setCustomerUpersonInfo(this.dialogUpersonForm)
          .then((res) => {
            if (res.success) {
              this.handleUpersonCloseDialog();
              this.$message.success("更新成功！");
              this.getData();
            }
          })
          .catch((err) => {
            this.$message({ message: err.message, type: "error" });
            this.handleUpersonCloseDialog();
          });
      });
    },
    handleUpersonCloseDialog() {
      this.$refs[this.dialogUpersonRefName].resetFields();
      this.dialogUpersonFormVisible = false;
    },
    reflushShareCode(index, data) {
      this.$confirm("确认刷新分享码？").then((_) => {
        reflushShareCode(data.customerId)
          .then((res) => {
            if (res.success) {
              this.$message.success("刷新成功！");
              this.getData();
            }
          })
          .catch((err) => {
            this.$message({ message: err.message, type: "error" });
          });
      });
    },
    handleLoginCustomer(index, data) {
      queryAdminLoginUser({ b2cUsersId: data.customerId }).then((res) => {
        if (res.success) {
          //this.$router.push({name:'login', params:{userName:res.data.userName, password:res.data.userPassword}});
          let baseHostName = "https://ai.weiquanai.com/?username=";
          if (data.roleCode == "anchor") {
            baseHostName = "http://zb.usmartdoc.com?username=";
          }
          window.open(
            baseHostName +
              res.data.userName +
              "&password=" +
              res.data.userPassword,
            "_blank",
          );
          //window.open("http://106.54.164.238:8082?username="+res.data.userName+"&password="+res.data.userPassword, "_blank");
        }
      });
    },
    onbeforeunloads(file) {
      this.loadingInstance = Loading.service({ text: "上传处理中" });
    },
    importDataSuccess(res, file) {
      console.log(res, file);
      if (res.success) {
        this.$message.success("导入数据成功");
        this.loadingInstance.close();
        this.dialogImportDataFormVisible = false;
        this.getData();
        this.$forceUpdate();
      }
    },
    importDataError(err, file, fileList) {
      this.$message({ message: err.message, type: "error" });
      this.loadingInstance.close();
    },
    handleImportData(dialogTitle) {
      this.dialogImportDataFormVisible = true;
      this.dialogImportDataTitle = dialogTitle;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleUnenableOrEnable(enableTag) {
      if (this.multipleSelection.length > 0) {
        changeOrderEnable({
          userInfos: this.multipleSelection,
          enableTag: enableTag,
        })
          .then((res) => {
            if (res.success) {
              this.$message.success("限制成功！");
              this.getData();
            }
          })
          .catch((err) => {
            this.$message({ message: err.message, type: "error" });
          });
      } else {
        this.$message({
          message: "请勾选要开启或者禁止接单的用户",
          type: "error",
        });
      }
    },
    openCustomerShareCode(index, row) {
      openCustomerShareEnable({
        customerId: row.customerId,
        enableTag: row.isOpenShareCode != null ? !row.isOpenShareCode : true,
      })
        .then((res) => {
          if (res.success) {
            this.$message.success("开启无限制成功！");
            this.getData();
          }
        })
        .catch((err) => {
          this.$message({ message: err.message, type: "error" });
        });
    },
    handlerEnableLowerOrder(enableTag) {
      if (this.multipleSelection.length > 0) {
        changeLowerOrderEnable({
          userInfos: this.multipleSelection,
          enableTag: enableTag,
        })
          .then((res) => {
            if (res.success) {
              this.$message.success("限制成功！");
              this.getData();
            }
          })
          .catch((err) => {
            this.$message({ message: err.message, type: "error" });
          });
      } else {
        this.$message({
          message: "请勾选要开启或者禁止接单的用户",
          type: "error",
        });
      }
    },
    getData() {
      queryCustomerList(this.queryForm, this.pagination).then((res) => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    goDetail(index, data) {
      console.log(index, data);
      this.$router.push({
        path: "/home/customerdetail",
        query: { customerId: data.customerId },
      });
    },
    uploadGifter(index, data) {
      uploadToGrifter(data.customerId)
        .then((res) => {
          if (res.success) {
            this.$message.success("上传骗子库成功！");
            this.getData();
          }
        })
        .catch((err) => {
          this.$message({ message: err.message, type: "error" });
        });
    },
    setCustomerUpPerson(index, data) {
      this.dialogUpersonTitle = "试客-" + data.customerName;
      this.dialogUpersonFormVisible = true;
      this.dialogUpersonForm.customerId = data.customerId;
    },
    customerSetting(index, data) {
      this.dialogTitle = "管理-" + data.customerName;
      this.dialogFormVisible = true;
      getCustomerSetting(data.customerId)
        .then((res) => {
          if (res.success) {
            this.dialogForm = res.data;
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          this.$message({ message: err.message, type: "error" });
        });
    },
    unEnableUser(index, data) {
      changeUserUsed(data.customerId)
        .then((res) => {
          if (res.success) {
            this.$message.success("设置信息修改成功！");
            this.getData();
          }
        })
        .catch((err) => {
          this.$message({ message: err.message, type: "error" });
        });
    },
    addData() {
      updateCustomerSetting(this.dialogForm)
        .then((res) => {
          if (res.success) {
            this.$message.success("设置账号信息成功！");
            this.dialogFormVisible = false;
            this.getData();
          }
        })
        .catch((err) => {
          this.$message({ message: err.message, type: "error" });
        });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm();
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm();
      //切换页面恢复到顶部
      this.scrollTop = 0;
      this.saveScroll();
    },
  },
};
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
